export default `uniform float delta;
void main() {
    vec2 uv = gl_FragCoord.xy / resolution.xy;
    vec4 pos = texture2D(texturePosition, uv);
    vec4 vel = texture2D(textureVelocity, uv);

    pos.xyz += vel.xyz * (delta / 16.0);

    gl_FragColor = pos;
}`